;(function() {
  'use strict'

  angular.module('glow.reporting').component('surveyReportRestrictedAnalysis', {
    templateUrl: 'restricted-analysis.html',
  })
})()
